// Logger utility for the application
export const authLogger = {
  debug: (message: string, data?: unknown) => {
    if (import.meta.env.DEV) {
      console.log(`[AUTH DEBUG] ${message}`, data || "");
    }
  },
  info: (message: string, data?: unknown) => {
    if (import.meta.env.DEV) {
      console.log(`[AUTH INFO] ${message}`, data || "");
    }
  },
  warn: (message: string, data?: unknown) => {
    if (import.meta.env.DEV) {
      console.warn(`[AUTH WARN] ${message}`, data || "");
    }
  },
  error: (message: string, error?: unknown) => {
    // Always log errors, but use structured logging in production
    if (import.meta.env.DEV) {
      console.error(`[AUTH ERROR] ${message}`, error || "");
    } else {
      // In production, send to error tracking service
      console.error(`[AUTH ERROR] ${message}`);
    }
  },
};

export const logApiError = (error: unknown, context: string) => {
  if (import.meta.env.DEV) {
    console.error(`[API ERROR - ${context}]`, error);
  } else {
    console.error(`[API ERROR - ${context}]`);
  }
};
